import React from 'react';
import { getTrackBackground, Range } from 'react-range';
import { useTheme } from 'styled-components';

import { StartEndDecorator, Thumb, Track, TrackContainer } from '../DraggableTracks.styles';

interface TwoThumbsDraggableTrackProps {
  step: number;
  min: number;
  max: number;
  values?: any;
  disabled?: boolean;
  onValuesChange: (min: number, max: number) => void;
}

const TwoThumbsDraggableTrack = ({
  step,
  min,
  max,
  values,
  disabled,
  onValuesChange,
}: TwoThumbsDraggableTrackProps) => {
  const [valuesLocal, setValuesLocal] = React.useState([min, max]);
  const theme = useTheme();

  React.useEffect(() => {
    if (values && values[0] <= values[1]) {
      setValuesLocal(values);
    }
  }, [values]);

  return (
    <Range
      values={valuesLocal}
      step={step}
      min={min}
      max={max}
      onChange={(newValues) => {
        setValuesLocal(newValues);
        onValuesChange(newValues?.[0], newValues?.[1]);
      }}
      disabled={disabled}
      renderTrack={({ props, children }) => (
        <TrackContainer onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
          <StartEndDecorator $start />
          <Track
            ref={props.ref}
            style={{
              background: getTrackBackground({
                values: valuesLocal,
                colors: [theme.colors.neutrals.c100, theme.colors.main.c300, theme.colors.neutrals.c100],
                min,
                max,
              }),
            }}
          >
            {children}
          </Track>
          <StartEndDecorator />
        </TrackContainer>
      )}
      renderThumb={({ props }) => <Thumb {...props} />}
    />
  );
};

export default TwoThumbsDraggableTrack;
